import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class DocumentoElectronicoResumenService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    ObtenerEmitidos(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $periodo: Date) {
            documentoElectronicoResumen {
              obtenerEmitidos(empresa_rut: $empresa_rut, periodo: $periodo) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  tipo_dte_codigo
                  tipoDescripcionAbreviada
                  tipoDescripcion
                  pendientes
                  enviados
                  cRespuesta
                  sRespuesta
                  aceptados
                  reparos
                  rechazados
                  total
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.documentoElectronicoResumen.obtenerEmitidos;
            callback({ mensajes, respuesta });
        });
    }
    ObtenerEmitidosExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $periodo: Date) {
            documentoElectronicoResumen {
              obtenerEmitidosExcel(empresa_rut: $empresa_rut, periodo: $periodo) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.documentoElectronicoResumen.obtenerEmitidosExcel;
            callback({ mensajes, respuesta });
        });
    }
    ObtenerRecibidos(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $desde: Date, $hasta: Date, $tipo_dte_codigo: Decimal, $statusDocumento: Decimal) {
            documentoElectronicoResumen {
              obtenerRecibidos(empresa_rut: $empresa_rut, desde: $desde, hasta: $hasta, tipo_dte_codigo: $tipo_dte_codigo, statusDocumento: $statusDocumento) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  tipo_dte_codigo
                  tipoDescripcion
                  cantidad
                  monto_exento
                  monto_neto
                  impuesto_adicional
                  total
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.documentoElectronicoResumen.obtenerRecibidos;
            callback({ mensajes, respuesta });
        });
    }
    ObtenerRecibidosExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $desde: Date, $hasta: Date, $tipo_dte_codigo: Decimal, $statusDocumento: Decimal) {
            documentoElectronicoResumen {
              obtenerRecibidosExcel(empresa_rut: $empresa_rut, desde: $desde, hasta: $hasta, tipo_dte_codigo: $tipo_dte_codigo, statusDocumento: $statusDocumento) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.documentoElectronicoResumen.obtenerRecibidosExcel;
            callback({ mensajes, respuesta });
        });
    }
}
DocumentoElectronicoResumenService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DocumentoElectronicoResumenService_Factory() { return new DocumentoElectronicoResumenService(i0.ɵɵinject(i1.GraphQLClient)); }, token: DocumentoElectronicoResumenService, providedIn: "root" });
